import {
  GroupParticipantsResource,
  ParticipantResource,
} from '../../../People/Group/GroupParticipantsStore/Types';
import { FilterOption } from './UseParticipantDynamicTypeaheadSelect/Types';

const newParticipantIncluded = (
  option: FilterOption,
  newParticipants: ReadonlyArray<ParticipantResource>,
): boolean => newParticipants.map((p) => p.payload.id).includes(parseInt(option.payload.value));

const newGroupIncluded = (
  option: FilterOption,
  newGroups: ReadonlyArray<GroupParticipantsResource>,
): boolean => newGroups.map((p) => p.payload.id).includes(parseInt(option.payload.value));

export const isOptionDisabled =
  (
    newParticipants: ReadonlyArray<ParticipantResource>,
    newGroups: ReadonlyArray<GroupParticipantsResource>,
  ) =>
  (option: FilterOption): boolean =>
    option.payload.type
      .map((type) => {
        switch (type) {
          case 'group':
            return newGroupIncluded(option, newGroups);
          case 'participant':
            return newParticipantIncluded(option, newParticipants);
        }
      })
      .getOrElseValue(false);
